import { render, staticRenderFns } from "./HudComponent.vue?vue&type=template&id=13ba6d97&"
import script from "./HudComponent.vue?vue&type=script&lang=js&"
export * from "./HudComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports